import { render, staticRenderFns } from "./ErrorIcon.vue?vue&type=template&id=71181620&scoped=true"
var script = {}
import style0 from "./ErrorIcon.vue?vue&type=style&index=0&id=71181620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71181620",
  null
  
)

export default component.exports